import PropTypes from 'prop-types';

const LoadingButton = (props) => {
  const {
    children,
    loading = false,
    succeeded = false,
    checked = false,
    disabled = false,
    className = '',
    type = 'button',
    ...other
  } = props;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type
    <button type={type} disabled={disabled} className={className} {...other}>
      {loading && (
        <i className="fas fa-spinner-third animation-momentum-spin me-2" />
      )}
      {succeeded && <i className="far fa-check me-2" />}
      {checked && <i className="pe-2 fas fa-circle-check" />}
      {children}
    </button>
  );
};

export default LoadingButton;

LoadingButton.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  succeeded: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
};
